export default "__VITE_ASSET__CBj2kQJb__"